import moment from 'moment'

export class Logger {
  constructor(name = 'Logger', alert = false) {
    /** @private */
    this.name = name
    this.alert = alert;
  }

  static alert = {
    call: (message) => null,
  }

  _time() {
    return moment().format('YYYY-MM-DD HH:mm:ssZ')
  }

  /**
   * @private
   * @param {'log' | 'info' | 'debug' | 'error' | 'warn'} method 
   * @param  {...any} args 
   */
  call(method, ...args) {
    const message = [this._time(), `${method.toUpperCase()} [${this.name}]`, ...args]
    if (this.alert) {
      setTimeout(() => {
        try {
          Logger.alert.call(message.map(s => this.serialize(s)).join(' '))
        } catch (e) {
          console.error(e)
        }
      }, 10)
    }
    return console[method](...message)
  }

  /**
   * @private
   * @param {any} value 
   */
  serialize(value) {
    switch (typeof value) {
      case 'number':
      case 'string':
      case 'boolean':
      case 'symbol':
      case 'undefined':
        return value
      case 'object':
        if (!value) {
          return value
        }
        try {
          return JSON.stringify(value, null, 2)
        } catch (_) {
          return `${value}`
        }
      case 'function':
        return `${value}`
    }
    return `${value}`
  }

  log(...args) {
    return this.call('log', ...args)
  }

  error(...args) {
    return this.call('error', ...args)
  }

  info(...args) {
    return this.call('info', ...args)
  }

  debug(...args) {
    return this.call('debug', ...args)
  }

  warn(...args) {
    return this.call('warn', ...args)
  }
}